import { ComponentAPI } from '@philips-emr/tws-core';

export interface Metadata {
  [key: string]: string | boolean | number | Metadata[] | undefined;
  children: Metadata[];
  componentType: string;
  enabled: boolean;
  entry: string;
  fieldType: string;
  id: string;
  label: string;
  title: string | undefined;
  width: string;
}

class DynamicFieldsAPI extends ComponentAPI {

  setMetadata(metaData: Metadata): void {
    this.setState({ metaData });
  }

  getMetadata(): Metadata {
    return this.state.metaData;
  }
  
}
export default DynamicFieldsAPI;
